<template>
    <div>
        <!-- 头部 -->
        <top></top>
        <el-row class="exmain">
            <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
            <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
                <div class="active-content-wrap">
                    <p v-if="langSet == 'zh' || content.en_title.length == 0" class="news-detail-title">{{content.title}}</p>
                    <p v-if="langSet == 'en' && content.en_title.length > 0" class="news-detail-title">{{content.en_title}}</p>
                    <div v-if="langSet == 'zh' || content.en_content.length == 0" class="active-content" v-html="content.content">{{content.content}}</div>
                    <div v-if="langSet == 'en' && content.en_content.length > 0" class="active-content" v-html="content.en_content">{{content.en_content}}</div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="3" :md="3" :lg="5" :xl="5"></el-col>
        </el-row>
        <!-- 底部 -->
        <bottom></bottom>
    </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { getInformationDetail } from "@/api/api";
export default {
    components: { top, bottom},
    data() {
        return {
            content:{
                en_title: '',
                en_content: ''
            },
            langSet: ''
        };
    },
    created() { 
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.id = this.$route.query.id;
        //console.log(this.id)
        this.getDetail(this.id);
    },
    computed:{

    },
    methods: {
        getDetail(id) {
            let data = this.$qs.stringify({
                id
            })
            getInformationDetail(data).then(res=>{
                //console.log(res.data.rst)
                if(res.data.errno == 0){
                    this.content = res.data.rst
                }
            }).catch(err=>{
                console.log(err)
            })
        },
    }
}
</script>
<style scoped>
    .exmain{
        line-height: normal;
    }
</style>
<style lang="scss">
.news-detail-title{text-align: center;line-height: 70px;font-size: 24px;color: #464343;}
@media only screen and (max-width: 767px){
    .news-detail-title{font-size: 18px;line-height: 0.7rem}
}
</style>